Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketChangeStatusToPendingView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/action/ticket_change_status_to_pending']
  id: 'ticket-change-status-to-pending-container'

  events:
    'click #change-ticket-status-to-pending' : 'onChangeStatusToPending'

  initialize:({ticket})=>
    @ticket = ticket
    @listenTo(Backbone, 'reply:disable-change-to-pending-button', @_disableChangeToPendingButton)
    @listenTo(Backbone, 'reply:reply-failed', @render)

  render: =>
    @$el.html(@template({canBeChangedToPending: @_canBeChangedToPendingStatus()}))
    @

  onChangeStatusToPending: =>
    @_warnTicketTabWillClose(@changeStatusToPending)

  changeStatusToPending: =>
    @_disableChangeToPendingButton()
    @ticket.ticketPendig(
      error:(response) =>
        @_handleResponseError(response)
      success:(response) =>
        @_handleResponseSuccess(response)
    )

  _warnTicketTabWillClose: (callback) =>
    swal
      title: I18n.t('customer.dashboard.conversations.details.pending_ticket_confirmation.are_you_sure')
      text: I18n.t('customer.dashboard.conversations.details.pending_ticket_confirmation.description')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('customer.dashboard.conversations.details.pending_ticket_confirmation.confirm')
      cancelButtonText: I18n.t('customer.dashboard.conversations.details.pending_ticket_confirmation.cancel')
      closeOnConfirm: true
      callback

  _canBeChangedToPendingStatus:=>
    @ticket.isAssigned() && !@_isPending()

  _isPending:=>
    @ticket.getStatus() == 'Pending'

  _handleResponseError: (response)=>
    @_enableChangeToPendingButton()
    @_showError()

  _showError:=>
    swal
      title: I18n.t 'customer.dashboard.conversations.ticket_can_not_change_to_pending'
      type: 'error'
      closeOnConfirm: true
      confirmButtonText: 'Ok'

  _handleResponseSuccess: (response)=>
    @_closeTicketTab()

  _closeTicketTab: =>
    @trigger('ticket:tab:closeRequired')

  _disableChangeToPendingButton:()=>
    @$el.find('#change-ticket-status-to-pending').attr('disabled', 'disabled')

  _enableChangeToPendingButton:()=>
    @$el.find('#change-ticket-status-to-pending').removeAttr('disabled')
